import React from 'react';
import clsx from 'clsx';
import { StatsCard } from 'common/components';
import { useStyles } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS, TABLES_KEYS } from 'features/command-center/constants';
import useDatatable, { getColumnPreferences, getColumnsToRender } from 'hooks/datatable';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import DataTable from 'UI/components/organisms/DataTable';

import { formatFallOffsByRecruiterResponse } from '../../fallOffsBoard.utils';

import { FALLOFFS_BY_RECRUITER_COLUMNS, ORDER_BY_OPTIONS } from './FallOffByRecruiter.columns';
import { TransactionsByRecruiter } from './TransactionsByRecruiter';

const TABLE_KEY = TABLES_KEYS.fallOffsBoardByRecruiter;
const initialPreferences = getColumnPreferences(
  TABLE_KEY,
  0,
  ORDER_BY_OPTIONS,
  FALLOFFS_BY_RECRUITER_COLUMNS
);

export const FallOffsByRecruiter = ({ queryParams }) => {
  const classes = useStyles();
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.fallOffsByRecruiter}?${queryParams}`;

  const { data, listState, columnPreferences, handleColumnSortChange } = useDatatable({
    key: TABLE_KEY,
    apiInstance: SECONDARY_API_CLIENT,
    columnsDefinitions: FALLOFFS_BY_RECRUITER_COLUMNS,
    endpoint,
    formatResponse: formatFallOffsByRecruiterResponse,
    initialPreferences,
    orderByOptions: ORDER_BY_OPTIONS
  });

  const { isLoading, showWholeSkeleton } = listState;
  const { columns } = columnPreferences;
  const finalColumns = getColumnsToRender(columns);
  const isEmpty = Array.isArray(data) && data.length === 0;

  return (
    <StatsCard header={strings.commandCenter.fallOffsBoard.byRecruiter} paddingContent={0}>
      <DataTable
        className={clsx(classes.mediumWeightRow, {
          [classes.firstRow]: !isEmpty
        })}
        columns={finalColumns}
        components={{ TableToolbar: () => null }}
        data={data}
        elevation={0}
        expandableRows
        expandableRowsHeader={false}
        filter={false}
        loading={showWholeSkeleton}
        onColumnSortChange={handleColumnSortChange}
        refreshing={isLoading}
        rowsExpanded={[]}
        search={false}
        selectableRows="none"
        viewColumns={false}
        renderExpandableRow={rowData => {
          const recruiterIdIndex = 0;
          return (
            <TransactionsByRecruiter
              columns={finalColumns}
              selectedRecruiterId={rowData[recruiterIdIndex]}
              queryParams={queryParams}
            />
          );
        }}
      />
    </StatsCard>
  );
};
